import Link from 'next/link'
import { useState } from 'react'
import { MyBtn } from '~/components/ui/MyBtn'
import { MyLink } from '~/components/ui/MyLink'
import { MyModal } from '~/components/ui/MyModal'
import Stepper from './Stepper'

interface Props {
  visible: boolean
  close: () => void
  availablePoints: number
  buyFn: (times: number) => Promise<void>
}

export default function BuyTimesModal({
  visible,
  close,
  availablePoints,
  buyFn,
}: Props) {
  const [times, setTimes] = useState(availablePoints >= 2 ? 1 : 0)
  const [loading, setLoading] = useState(false)
  const maxTimes = (availablePoints / 2) >> 0

  const handleBuy = async () => {
    setLoading(true)
    await buyFn(times)
    setLoading(false)
  }

  return (
    <MyModal
      open={visible}
      title="积分购买次数"
      onCancel={close}
      maskStyle={{
        backgroundColor: 'rgba(0,0,0,0.8)',
      }}
      width={375}
      footer={null}
      dark
      centered
    >
      <p className="text-xs text-neutral-400 mb-7 -mt-3">
        * 每消耗2积分将获得1次AI创作次数，可用于所有模型
      </p>

      <div className="flex items-center justify-between text-neutral-800">
        <span className="text-sm text-neutral-400 font-medium">购买数量</span>
        <Stepper min={0} max={maxTimes} value={times} onChange={setTimes} />
      </div>
      <div className="w-full h-px bg-neutral-200 my-4"></div>
      <div className="flex items-center justify-between font-medium">
        <span className="text-sm text-neutral-400">消耗积分</span>
        <span className="text-error">{times * 2} 积分</span>
      </div>
      <div className="flex items-center justify-between font-medium mt-4">
        <span className="text-sm text-neutral-400">可用积分</span>
        <span className="text-neutral-800">{availablePoints} 积分</span>
      </div>
      <div className="bg-neutral-200 text-neutral-500 text-center text-xs py-2 rounded-2xl mt-4">
        积分不足？可前往{' '}
        <MyLink href="/integral" className="text-primary" exist={true}>
          「我的积分」
        </MyLink>{' '}
        页面充值积分
      </div>
      <MyBtn
        type="primary"
        className="w-full mt-4"
        onClick={handleBuy}
        loading={loading}
        disabled={times === 0}
      >
        确定
      </MyBtn>
    </MyModal>
  )
}
